
export const aadConfig = {
    clientAad: {
        clientId: "844e3d63-bed2-416e-86af-bb35e226d765",
        authorityDomain: "newstatements.b2clogin.com",
        authorityRoot: "https://newstatements.b2clogin.com/newstatements.onmicrosoft.com/",
        policies: {
            signUpSignIn: "b2c_1_signup_signin",
            forgotPassword: "b2c_1_password_reset",
            editProfile: "b2c_1_edit_profile"
        },
        redirectUri: "/",
        postLogoutRedirectUri: "/loggedout"
    },
    requiredScopes: ["https://newstatements.onmicrosoft.com/api.newstatements/all.read"]
}
